import { SuccessfulApiResponse } from "@eryxcoop/appyx-comm";

export default class SoldBoxesByCustomerAndArticleResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                articles: [
                    { code: "BAG001", name: "Baguette", category: "COMMODITIE" },
                    { code: "CRO001", name: "Croissant", category: "Sin categoría" },
                ],
                rows: [
                    { customer: "Panadería Central", created_by: "michael@dundermifflin.com", boxes: { BAG001: 12, CRO001: 5 } },
                    { customer: "Comercial San Martín", created_by: "michael@dundermifflin.com, karen@dundermifflin.com", boxes: { BAG001: 3 } },
                ],
            },
            errors: [],
        };
    }

    articles() {
        return this.content().articles.map((article) => ({ code: article.code, name: article.name, category: article.category }));
    }

    rows() {
        return this.content().rows.map((row) => ({
            customer: row.customer,
            createdBy: row.created_by,
            boxesByArticleCode: row.boxes,
        }));
    }
}
